<script setup lang="ts">
import LoadingIndicator from './components/layouts/LoadingIndicator.vue';
</script>

<template>
  <LoadingIndicator/>
  <router-view></router-view>
</template>
